module.exports = __webpack_public_path__ + "static/media/Clock.07b8b75b.svg";